var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formData && _vm.formData.length > 0
        ? _c(
            "el-card",
            {
              staticClass: "mb10",
              attrs: {
                bordered: false,
                shadow: "never",
                "body-style": { paddingBottom: 0 },
              },
            },
            [
              _c("table-form", {
                attrs: {
                  columns: _vm.columnCount,
                  "form-data": _vm.formData,
                  loading: _vm.loading,
                  immediate: _vm.immediate,
                },
                on: { search: _vm.handleSearch, reset: _vm.resetSearch },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "btn-group",
                      fn: function () {
                        return [_vm._t("btn-group")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-card",
        { attrs: { bordered: false, shadow: "never" } },
        [
          _c(
            "div",
            { class: { mb10: !!_vm.$slots["page-operation"] } },
            [_vm._t("page-operation")],
            2
          ),
          _c(
            "table-content",
            _vm._g(
              _vm._b(
                {
                  ref: "tableContent",
                  attrs: {
                    loading: _vm.loading,
                    columns: _vm.columns,
                    list: _vm.list,
                    total: +_vm.total,
                    formatter: _vm.formatter,
                    page: _vm.queryParams.page,
                    limit: _vm.queryParams.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.queryParams, "page", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.queryParams, "limit", $event)
                    },
                    pagination: _vm.pagination,
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm._l(_vm.$scopedSlots, function (_, name) {
                        return {
                          key: name.slice(6),
                          fn: function (scope) {
                            return name.indexOf("table-") === 0
                              ? [_vm._t(name, null, null, scope)]
                              : undefined
                          },
                        }
                      }),
                    ],
                    null,
                    true
                  ),
                },
                "table-content",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }